// Search terms no longer travel in the query string: getList() in
// inspectionPlansService sends the list params in a POST body, so the list
// length is only bounded by what stays responsive to search. The cap is a
// guard against a whole spreadsheet being pasted in by accident.
export const MAX_SEARCH_TERMS = 5000;

// Mirrors EXACT_SEARCH_TERM_THRESHOLD on the API: past this many terms the
// search matches whole values instead of fragments, which is what keeps a
// several-hundred-item list fast.
export const EXACT_SEARCH_TERM_THRESHOLD = 25;

export const SEARCH_LIMIT_MESSAGE = `You can search up to ${MAX_SEARCH_TERMS} items at a time. Please shorten your list.`;
export const EXACT_SEARCH_HINT = `Lists longer than ${EXACT_SEARCH_TERM_THRESHOLD} items are matched exactly, so enter complete ids or names.`;

// Lists get pasted in from spreadsheets, so accept the separators those produce
// (new line, tab, semicolon) alongside the comma users type by hand.
export const parseSearchTerms = (textStr) =>
  textStr?.length
    ? textStr
        .split(/[,;\t\r\n]+/)
        .map((v) => v.trim())
        .filter((v) => v.length)
    : [];

// A single-line input drops line breaks from its value, which would glue a
// pasted spreadsheet column into one unusable term. Turn the breaks into the
// separator the field already understands.
export const normalizePastedSearch = (text) => text.replace(/[\t\r\n]+/g, ',');

export const getSearchError = (terms) =>
  terms.length > MAX_SEARCH_TERMS ? SEARCH_LIMIT_MESSAGE : null;

export const isExactSearch = (terms) =>
  terms.length > EXACT_SEARCH_TERM_THRESHOLD;
